import { StyleClass } from "../../Shared/Styles/CSS";
import {
    GetQuickJournalTheme,
    ResolveQuickJournalThemeName,
    type QuickJournalThemeSelectionName,
} from "../QuickJournal/View/QuickJournalTheme";

export const quickJournalHeatmapFlashDurationInMilliseconds = 1800;
export const bottomBarCloseDurationInMilliseconds = 0;

export const calcTarget_BottomBar = "calcTarget_BottomBar";

export function GetQuickJournalOverlayStyleClass(
    quickJournalThemeName: QuickJournalThemeSelectionName,
) {
    const quickJournalTheme = GetQuickJournalTheme(quickJournalThemeName);
    const resolvedThemeName = ResolveQuickJournalThemeName(
        quickJournalThemeName,
    );

    return StyleClass(`quickJournalOverlay_${resolvedThemeName}`, {
        backgroundColor: quickJournalTheme.overlay.backgroundColor,
        backgroundImage: quickJournalTheme.overlay.backgroundImage,
        backgroundRepeat: `no-repeat`,
        backgroundSize: `100% 100%`,
        bottom: 0,
        left: 0,
        pointerEvents: `none`,
        position: `fixed`,
        right: 0,
        top: 0,
        zIndex: 19999,
    });
}
